import {TextField} from "@mui/material";
import React, {useContext} from "react";
import {EditorContext} from "../../../utils/contexts";
import Switcher from "../components/Switcher";
import {Label} from "../Steps/components";

export default function LikeOnFacebook() {
  const {settings, updateSettings} = useContext(EditorContext)

  settings.settings.url_to_like = settings.settings.url_to_like || ''
  settings.settings.use_location_for_url = settings.settings.use_location_for_url || false

  const updateURL = (event) => {
    const customSettings = {...settings.settings, url_to_like: event.target.value}
    updateSettings({settings: customSettings})
  }

  const toggleUseLocation = () => {
    const customSettings = {...settings.settings, use_location_for_url: !settings.settings.use_location_for_url}
    updateSettings({settings: customSettings})
  }

  return (
    <>
      <Label>
        <span>URL my visitor is on</span>
        <Switcher checked={settings.settings.use_location_for_url} onChange={toggleUseLocation}/>
      </Label>

      {!settings.settings.use_location_for_url &&
      <TextField fullWidth variant="outlined" label="URL to like" value={settings.settings.url_to_like}
                 onChange={updateURL} placeholder="example.com" size='small'/>}
    </>
  )
}
